import { capitalizeFirstLetter, formatDate } from "../../../utils";

export const SETTINGS_USERS_FETCH_LIMIT = 250;

export const USER_STATUS_FILTERS = [
  { id: "all", label: "All users" },
  { id: "active", label: "Active" },
  { id: "inactive", label: "Inactive" },
];

export const getUserId = (user) => user?.id || user?._id;

export const getUsersFromResponse = (data) =>
  data?.users || data?.data?.users || data?.data || [];

export const getUserPlatformLabel = (user = {}) => {
  if (user.accountHolder) return "Account holder";
  const role = user.role || user.type || user.authority;
  return role ? capitalizeFirstLetter(role) : "User";
};

export const getUserTenantRoleNames = (user = {}) =>
  (user.tenantRoles || [])
    .map((role) => role.name)
    .filter(Boolean);

export const getUserStatusMeta = (user = {}) => {
  const isActive = Boolean(user.active);
  return {
    isActive,
    label: isActive ? "Active" : "Inactive",
    color: isActive ? "green" : "red",
  };
};

export const formatUserDate = (value) => {
  if (!value) return "—";
  return formatDate(value, null, true);
};

export const buildUserStats = (users = []) => {
  const active = users.filter((user) => user.active).length;
  const inactive = users.length - active;
  const withoutRoles = users.filter(
    (user) => getUserTenantRoleNames(user).length === 0
  ).length;

  return {
    total: users.length,
    active,
    inactive,
    withoutRoles,
  };
};

export const filterUsersByStatus = (users = [], statusFilter = "all") => {
  if (statusFilter === "active") {
    return users.filter((user) => user.active);
  }
  if (statusFilter === "inactive") {
    return users.filter((user) => !user.active);
  }
  return users;
};

export const filterUsersBySearch = (users = [], searchTerm = "") => {
  const query = searchTerm.trim().toLowerCase();
  if (!query) return users;

  return users.filter((user) => {
    const haystack = [
      user.fullName,
      user.email,
      user.firstName,
      user.lastName,
      user.phone,
      getUserPlatformLabel(user),
      ...getUserTenantRoleNames(user),
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    return haystack.includes(query);
  });
};

export const paginateUsers = (users = [], pageIndex = 0, pageSize = 20) => {
  const start = pageIndex * pageSize;
  const end = start + pageSize;
  const pageUsers = users.slice(start, end);
  const totalPages = Math.max(1, Math.ceil(users.length / pageSize));

  return {
    users: pageUsers,
    totalDocs: users.length,
    totalPages,
    page: pageIndex + 1,
    hasNext: pageIndex + 1 < totalPages,
    hasPrev: pageIndex > 0,
    nextPage: pageIndex + 2,
    prevPage: pageIndex,
  };
};
